$ = jQuery

App =  {

	controller : false
	wHeight : false
	isMenuMoving : false
	
	init : ->
		console.log 'App init'
		
		# Init scrollMagic
		@controller = new ScrollMagic.Controller() ; 
		@wHeight = $(window).height()

		# Show grid for debug (dev only)
		@debugManager()

		# Menus
		@mobileMenuManager()
		@menuStickyManager()

		# Tease Metiers
		if $('.tease-metier').length
			@teaseMetierManager()

		# Manage file inputs
		@inputFileManager()

		# Smooth scroll for anchor
		@anchorManager()

		# Video asynchrone load
		@videoManager()

		# overlays
		@overlaysManager()

		# alert
		@alertManager()

		# reveal on scroll
		@revealManager()

		# Special hover 
		@hoverManager()


	menuStickyManager : ->

		# Reveal sticky menu on scroll
		if not Config.isMobile()
			scene = new ScrollMagic.Scene({triggerElement: '#site-header', triggerHook: 0, force3D:true})
				.setClassToggle '#site-header', 'sticky'
				.setPin '#site-header'
				.addTo @controller


	mobileMenuManager : ->
		
		# Open / Close menu
		$('.cta-menu-mobile').on "click", (ev) ->
			mobileOverlay = $('.block-menu-mobile')
			if mobileOverlay.hasClass('active')
				# allow scroll
				$('body').css('overflow', 'initial')
				# remove class
				mobileOverlay.removeClass('active')
				# Hide menu
				TweenLite.to(mobileOverlay, 0.6, {x:'-105%', ease:Quint.easeInOut})
			else
				# disable scroll
				$('body').css('overflow', 'hidden')
				# add class
				mobileOverlay.addClass('active')
				# Show menu
				TweenLite.to(mobileOverlay, 0.6, {x:'0%', ease:Quint.easeInOut})
				

		# Submenus manager
		$('#nav-mobile [has-accordeon]').on "click", (ev) ->
			accordeon = $(@).find('.accordeon-container')

			if $(@).hasClass('active')
				$(@).removeClass('active')
				TweenLite.to(accordeon, 0.6, {height:0, ease:Quint.easeInOut})
			else
				$(@).addClass('active')
				TweenLite.set(accordeon, {height:"auto"})
				TweenLite.from(accordeon, 0.6, {height:0, ease:Quint.easeInOut})


	teaseMetierManager : ->

		_this = @

		# scroll on click on goutte cta
		$('.tease-metier .cta_goutte').on "click", (ev) ->
			metier = $(@).parents('.tease-metier')
			if metier.index() == $('.tease-metier').length - 1				
				target = metier.parents('section').next()
				offset = target.offset().top - 135
			else
				target = metier.next()
				offset = target.offset().top

			TweenLite.to window, 1, {scrollTo: offset, ease:Quint.easeInOut}

		if not Config.isMobile()

			$.each $('.tease-metier'), (i,teaseElt) ->

				titleElt = $(teaseElt).find('.tease-metier--content')
				
				# Sticky title on scroll
				scene = new ScrollMagic.Scene({triggerElement: titleElt[0], offset : titleElt.height() / 2 , duration: _this.wHeight * 0.4 - titleElt.height() / 2, force3D:true})
					.setPin(titleElt[0])
					.addTo(_this.controller)

	inputFileManager : ->
		$('input[type=file]').on 'change', (ev) ->
			files = @.files
			console.log files.length
			cont = $(@).parents('.input-group')
			for file in files
				cont.find('.file-container').html(file.name)

			if files.length
				# show trash cta
				TweenLite.to cont.find('.cta-remove'), 0.6, {autoAlpha:1, ease:Quint.easeIn}

		$('.input-group_file').find('.cta-remove').on "click", (ev) ->
			cont = $(@).parents('.input-group')
			cont.find('input[type=file]').replaceWith( cont.find('input[type=file]').val('').clone( true ) )
			cont.find('.file-container').html('Choisir un fichier')	
			TweenLite.to @, 0.6, {autoAlpha:0, ease:Quint.easeOut}

	anchorManager : ->
		$('*[smooth-scroll]').on "click", (ev) ->
			ev.preventDefault()
			target = $( $(@).attr('href') )
			offset = $('#site-header').height()
			TweenLite.to(window, 1, { scrollTo: {y: target, offsetY: offset}, ease:Quint.easeInOut })


	videoManager : ->
		$.each $('.video--embed'), (i, elt) ->
			youtubeId = $(elt).attr('data-embed')
			$(elt).children('.cta-play-container').on "click", (ev) ->
				ev.preventDefault()
				ev.stopPropagation()
				iframe = document.createElement("iframe");
				iframe.setAttribute("frameborder", "0");
				iframe.setAttribute("allowfullscreen", "");
				iframe.setAttribute("src", "https://www.youtube.com/embed/" + youtubeId + "?rel=0&showinfo=0&autoplay=1")
				# elt.innerHTML = ""
				elt.appendChild(iframe)

	overlaysManager : ->

		# Show overlay
		$('[show-overlay]').on "click", (ev) ->
			overlay = $('.overlay-'+ $(@).attr('data-overlay'))
			$('body').css('overflow', 'hidden');
			tlShowOverlay = new TimelineLite
			tlShowOverlay.addLabel('start')
				.set(overlay, {autoAlpha:1})
				.fromTo(overlay, 0.8, {y:'-105%'}, {y:'0%', ease:Quint.easeInOut})

			# Hide overlay
			overlay.find('.cta_close').one "click", (ev) ->
				TweenLite.fromTo(overlay, 0.8, {y:'0%'}, {y:'105%', ease:Quint.easeInOut})
				TweenLite.set(overlay, {autoAlpha:0, delay: 0.8})
				$('body').css('overflow', 'visible');


		##################################	
		## Overlay 'poser une question' ##
		##################################

		# Hover event
		$('.cta-question-container').on "mouseenter", (ev) ->
			if not $(@).hasClass 'active'
				TweenLite.fromTo $('.question--hover'), 0.3, {width:'50px'}, {width: '254px', ease:Quint.easeOut}
				$(@).one 'mouseleave', (ev) ->
					TweenLite.to $('.question--hover'), 0.2, {width: '50px', ease:Quint.easeOut}

		# Show overlay anim
		tlShowQuestion = new TimelineLite({'paused':true, onReverseComplete: -> 
			TweenLite.set $('.block-contact'), {css:{position:'relative', left: 'auto', right: 'auto', bottom: 'auto', zIndex: 0}}
			TweenLite.set $('.block-contact'), {autoAlpha:1, y: '0%'}
		})
		tlShowQuestion.addLabel 'start'
			# Change CTA
			.to $('.cta-question'), 0.3, {backgroundColor: '#fff', ease:Quint.easeOut}, 'start'
			.fromTo $('.cta-question img.on'), 0.3, {autoAlpha:0, y:'0%'}, {autoAlpha:1, y:'-50%', ease:Quint.easeOut}, 'start'
			# show block contact
			.to $('.block-contact'), 0.8, {y:'0%', autoAlpha:1, ease:Quint.easeInOut}, 'start'

		# Click event
		$('.cta-question-container').on "click", (ev) ->
			if $(@).hasClass 'active'
				$(@).removeClass 'active'
				tlShowQuestion.reverse()
			else
				$(@).addClass 'active'
				# set block-contact to fixed
				TweenLite.set $('.block-contact'), {css:{position:'fixed', left: 0, right: 0, bottom: 0, zIndex: 400}}
				TweenLite.set $('.block-contact'), {y: '100%'}
				TweenLite.to $('.question--hover'), 0.3, {width: '50px', ease:Quint.easeOut}
				tlShowQuestion.play()

		reverseFunction : ->
			# set block-contact back in place
			TweenLite.set $('.block-contact'), {autoAlpha:1, css:{position:'unset', left: 'auto', right: 'auto', bottom: 'auto', zIndex: 0}}, 'start'

	alertManager : ->
		if $('.alert-container').length

			setTimeout ->
				TweenLite.fromTo $('.alert-container'), 0.8, {y:'-105%'}, {y:'0%', ease: Quint.easeInOut}
				TweenLite.to $('#content'), 0.8, {y:$('.alert-container').height(), ease: Quint.easeInOut, delay:0.05}

				$('.alert-container .cta_close').on "click", (ev) ->
					TweenLite.to $('#content'), 0.8, {y:0, ease: Quint.easeInOut}					
					TweenLite.fromTo $('.alert-container'), 0.8, {y:'0%'}, {y:'-105%', ease: Quint.easeInOut, delay:0.05}
			, 500


	revealManager : ->

		_this = @ 

		$('[scroll-reveal]').each ->
			tween = TweenMax.fromTo @, 0.8, {autoAlpha: 0, y: 50}, {autoAlpha:1, y:0, ease:Quint.easeOut}
			scene = new ScrollMagic.Scene({triggerElement: @, triggerHook: 0.9, force3D:true})
				.setTween tween
				.addTo _this.controller

	hoverManager : ->
		$('[up-down-hover]').each ->
			$(@).css('overflow', 'hidden')
			$(@).on "mouseenter", (ev) ->
				tlHover = new TimelineLite()
				tlHover.to $(@).find('.hover-elt'), 0.3, {y:'110%', ease:Quint.easeInOut}
				tlHover.set $(@).find('.hover-elt'), {y:'-110%'}
				tlHover.to $(@).find('.hover-elt'), 0.2, {y:'0%', ease:Quint.easeOut}

	debugManager : ->
		debugGrid = $('.wrapper').css('background-image')
		$('.wrapper').css('background-image', 'none')
		$('.overlay-fixed .overlay--container').css('background-image', 'none')
		$('.nav--list-container ul').css('background-image', 'none')
		
		$(window).keypress (ev) ->
			if ev.keyCode == 100
				if $('.wrapper').css('background-image') == 'none'
					$('.wrapper').css('background-image', debugGrid)
					$('.rappel--container').css('background-image', debugGrid)
				else
					$('.wrapper').css('background-image', 'none')
					$('.rappel--container').css('background-image', 'none')

	destroy : ->
		console.log "App destroy"
		
}